export const RE_CAPTCHA_SITE_KEY =
  process.env.SMART_CAPTCHA_SECRET_FRONTEND || '';

export const TEST_ID_RECAPTCHA = 'TEST_ID_RECAPTCHA';
